import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TooltipModule } from '../../common/tooltip/tooltip.module';
import { DialogHeaderComponent } from './dialog-header.component';

@NgModule({
  exports: [DialogHeaderComponent],
  imports: [CommonModule, TooltipModule, DialogHeaderComponent],
})
export class DialogHeaderModule {}
export { DialogHeaderComponent } from './dialog-header.component';
